/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const informationSecurityCybersecurityEnumsUnauthorizedAccessDetectedOptionEnum = {
    Yes: 'Yes',
    No: 'No',
    CannotSpecify: 'CannotSpecify',
} as const;

export type InformationSecurityCybersecurityEnumsUnauthorizedAccessDetectedOptionEnumKey =
    (typeof informationSecurityCybersecurityEnumsUnauthorizedAccessDetectedOptionEnum)[keyof typeof informationSecurityCybersecurityEnumsUnauthorizedAccessDetectedOptionEnum];

export type InformationSecurityCybersecurityEnumsUnauthorizedAccessDetectedOption =
    InformationSecurityCybersecurityEnumsUnauthorizedAccessDetectedOptionEnumKey;
